const getSupplierFax1 = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return business && business['Company Contact'] && business['Company Contact'].Fax
    ? business['Company Contact'].Fax.replace('+1 ', '').replace(/[\s()-]/g, '').slice(0, 3) : null;
};

export default getSupplierFax1;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierFax1.js